export enum PatientSubscriptionStatusType {
  TRIAL = 'TRIAL',
  TRIAL_CANCEL_REQUESTED = 'TRIAL_CANCEL_REQUESTED',
  ACTIVE = 'ACTIVE',
  RENEWAL_CANCEL_REQUESTED = 'RENEWAL_CANCEL_REQUESTED',
  CANCELLED = 'CANCELLED',
}

export interface GetCurrentPatientSubscriptionByUserID {
  id: string;
  expiresAt: string;
  trialExpiresAt: string;
  status: PatientSubscriptionStatusType;
}
